import { Link } from 'react-router-dom';
import { articles } from '@/mocks/siteData';

export default function CaseSection() {
  const featuredArticles = articles.filter((a) => a.featured);

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-12 md:mb-16">
          <div>
            <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
              精选案例
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950">
              实战案例与行业洞察
            </h2>
          </div>
          <Link
            to="/category/all"
            className="flex items-center gap-2 text-primary-600 hover:text-primary-700 text-sm font-medium transition-colors whitespace-nowrap"
          >
            <span>查看全部</span>
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.slug}`}
              className="group bg-background-50 rounded-2xl overflow-hidden transition-all duration-300 hover:-translate-y-1"
            >
              <div className="aspect-[16/9] overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="flex items-center gap-3 mb-3">
                  <span className="text-xs bg-secondary-100 text-secondary-700 px-2.5 py-1 rounded-full font-medium">
                    {article.categoryName}
                  </span>
                  <span className="text-xs text-foreground-500">{article.date}</span>
                </div>
                <h3 className="text-base md:text-lg font-bold text-foreground-950 mb-3 line-clamp-2 group-hover:text-primary-600 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <div className="flex items-center justify-between mt-4 pt-4 border-t border-background-200/60">
                  <div className="flex flex-wrap gap-1.5">
                    {article.tags.slice(0, 2).map((tag) => (
                      <span key={tag} className="text-xs text-foreground-500 bg-background-100 px-2 py-0.5 rounded">
                        #{tag}
                      </span>
                    ))}
                  </div>
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-time-line"></i>
                    {article.readTime}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}